import React from 'react';
import { Stack, Card, CardHeader, CardContent, Typography } from '@mui/material';
import Level from '../../employee/order/order-details/tabs/ParticipanDetailsTab/Level';


const Group = ({ event_name, event_price, event_schedule, participant_name, resort_name, level_details, levels }) => (
  <>
    <Card style={{ margin: '10px' }}>
      <CardHeader
        title={`${event_name} - ${participant_name}`}
      />
      <CardContent>
        <Stack direction="row" spacing={2}>
          <Stack>
            <Typography variant="h5">Ośrodek:</Typography>
            <Typography variant="h5">Cena:</Typography>
            <Typography variant="h5">Harmonogram:</Typography>
          </Stack>
          <Stack>
            <Typography sx={{ fontWeight: 'normal' }} variant="h5">{resort_name}</Typography>
            <Typography sx={{ fontWeight: 'normal' }} variant="h5">{event_price} zł/msc</Typography>
            <Typography sx={{ fontWeight: 'normal', whiteSpace: 'pre-line' }} variant="h5">{event_schedule}</Typography>
          </Stack>
        </Stack>
        {levels
          ? <Level levelDetails={level_details} sx={{ height: '40px' }}/>
          : null}
      </CardContent>
    </Card>
  </>
);

export default Group;
